import React from 'react';
import Icon from '../../../components/AppIcon';
import { QuickStat } from '../types';

interface QuickStatsGridProps {
  stats: QuickStat[];
}

const QuickStatsGrid = ({ stats }: QuickStatsGridProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-3">
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat.color}20` }}
            >
              <Icon name={stat.icon} size={20} color={stat.color} />
            </div>
            {stat.trend && (
              <div
                className={`flex items-center gap-1 text-xs font-medium ${
                  stat.trend.isPositive ? 'text-success' : 'text-error'
                }`}
              >
                <Icon
                  name={stat.trend.isPositive ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                />
                <span>{Math.abs(stat.trend.value)}%</span>
              </div>
            )}
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{stat.value}</p>
          <p className="text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsGrid;